import classNames from "classnames";
import { useTranslation } from "react-i18next";

// components
import OutlinedButton from "../../../components/common/OutlinedButton";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../components/common/PrimaryButton";
import { IAbsherButtonsProps } from "./models";

export const AbsherButtons = (props: IAbsherButtonsProps) => {
  const { onSkip, onConfirm } = props;
  const { t } = useTranslation();
  return (
    <div className={"row"}>
      <div className={"flex8"}>
        <PrimaryButton
          id={"signup_absher_confirm"}
          buttonType={PrimaryButtonType.ABSHER}
          onClick={onConfirm}>
          {t("lbl_confirm")}
        </PrimaryButton>
      </div>
      <div className={"flexDivider"} />
      <div className={"flex2"}>
        <OutlinedButton
          id={"signup_absher_skip"}
          onClick={onSkip}
          color={"#008852"}>
          <p className={classNames("subtitle2", "absher")}>{t("lbl_skip")}</p>
        </OutlinedButton>
      </div>
    </div>
  );
};
